export default __webpack_public_path__ + "static/media/youtubeIcon.292b22fe.svg";